import Moment from './_Moment';

export default class EditForm_Food extends Moment {
  constructor(props, context) {
    super(props, context, 'food');
  }
}
